import { render, staticRenderFns } from "./DimensionalPackingForm.vue?vue&type=template&id=caa6a7c4"
import script from "./DimensionalPackingForm.vue?vue&type=script&lang=js"
export * from "./DimensionalPackingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports